import { render } from "./AddButton.vue?vue&type=template&id=7f2e45da&scoped=true"
import script from "./AddButton.vue?vue&type=script&lang=js"
export * from "./AddButton.vue?vue&type=script&lang=js"

import "./AddButton.vue?vue&type=style&index=0&id=7f2e45da&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2e45da"],['__file',"src/views/ProductManage/ConfigManagement/components/Motor/ParameterFileComponent/AddButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f2e45da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f2e45da', __exports__)) {
    api.reload('7f2e45da', __exports__)
  }
  
  module.hot.accept("./AddButton.vue?vue&type=template&id=7f2e45da&scoped=true", () => {
    api.rerender('7f2e45da', render)
  })

}


export default __exports__